import { createReducer } from 'redux-starter-kit';
import { SET_IMAGES, ADD_IMAGE, SET_IMAGES_LOADING } from './actions';

const INITIAL_STATE = {
  imagesLoading: [],
  images: {}
};

export default createReducer(INITIAL_STATE, {
  [SET_IMAGES]: (state, action) => {
    state.images = action.payload;
  },
  [ADD_IMAGE]: (state, action) => {
    state.images = {
      ...state.images,
      [action.payload.key]: action.payload.chart
    };

    state.imagesLoading = state.imagesLoading.filter(
      (item: any) => item !== action.payload.key
    );
  },
  [SET_IMAGES_LOADING]: (state, action) => {
    state.imagesLoading = action.payload;
  }
});
